import { FC } from 'react';
import { UserRow } from '../types';
import { getDateDiffFromNow } from '../../../../../utils/dates';
import { Tooltip, TwoLinesCell } from '@silverfort/sf-components';
import { USER_STATUS_TO_LABEL } from '../../../consts';
import { UserStatus } from '../../../types/userStatus';

type Props = Pick<UserRow, 'status'>;

const getExcludedTillLabel = (excludedTill: Date) => {
    const hoursLeft = getDateDiffFromNow(excludedTill, 'hours');

    if (hoursLeft === 0) {
        return 'Less than hour left';
    } else if (hoursLeft === 1) {
        return '1 Hour left';
    } else if (hoursLeft < 24) {
        return `${hoursLeft} Hours left`;
    }

    return `${getDateDiffFromNow(excludedTill, 'days')} Days left`;
};

const StatusCell: FC<Props> = ({ status }) => {
    if (status.type === UserStatus.Unprotected) {
        return (
            <Tooltip title="Not part of a protected group">
                <span>{USER_STATUS_TO_LABEL[status.type]}</span>
            </Tooltip>
        );
    }

    return (
        <TwoLinesCell
            topText={USER_STATUS_TO_LABEL[status.type]}
            bottomText={status.excludedTill ? getExcludedTillLabel(status.excludedTill) : ''}
        />
    );
};

export default StatusCell;
